import React from 'react';
import tw, { styled } from 'twin.macro';

import { Panel, Button, Tooltip } from '@ubisend/pulse-components';

import { useAssistant } from '../hooks/index';
import AssistantPanel from './AssistantPanel';

const ToggleContainer = styled(Panel)`
  ${tw`absolute z-20 p-1 flex items-center justify-center`}
  box-sizing: border-box;
  bottom: 1rem;
  right: 1rem;
  width: 34px;
  height: 34px;
`;

const AssistantWidget = () => {
  const {
    open,
    messages,
    prompt,
    loading,
    handleOpen,
    handleClose,
    handlePromptChange,
    handleSubmit
  } = useAssistant();

  if (open) {
    return (
      <AssistantPanel
        messages={messages}
        prompt={prompt}
        loading={loading}
        onPromptChange={handlePromptChange}
        onSubmit={handleSubmit}
        onClose={handleClose}
      />
    );
  }

  return (
    <ToggleContainer>
      <Tooltip
        position={Tooltip.POSITIONS.LEFT}
        tooltip={<Tooltip.Content>Workflow Assistant</Tooltip.Content>}>
        <Button
          variant="inline"
          icon="sparkles"
          aria-label="Open workflow assistant"
          onClick={handleOpen}
        />
      </Tooltip>
    </ToggleContainer>
  );
};

export default AssistantWidget;
